module.exports = __webpack_public_path__ + "img/left_right_layout_5.7ce45eea.jpg";